import React from "react";
import { Button, message } from "antd";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import _ from "lodash";
import { FileExcelOutlined } from "@ant-design/icons";

export const ExportCSV = ({ csvData, fileName, columnNames }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName, columnNames) => {
    if (Array.isArray(csvData)) {
      try {
        const expectedResults = csvData.map((dataRecord) => {
          const exportDataObj = {};
          columnNames.forEach((column) => {
            if (dataRecord[column.dataIndex] !== undefined) {
              exportDataObj[column.title] = Array.isArray(
                dataRecord[column.dataIndex],
              )
                ? dataRecord[column.dataIndex].join()
                : dataRecord[column.dataIndex];
            }
          });
          return exportDataObj;
        });

        const ws = XLSX.utils.json_to_sheet(expectedResults);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
      } catch (err) {
        message.error(err);
      }
    } else {
      message.error("There are no valid data to export");
    }
  };

  return (
    <Button
      icon={<FileExcelOutlined />}
      type="primary"
      style={{ marginBottom: "15px" }}
      onClick={(e) => exportToCSV(csvData, fileName, columnNames)}
    >
      Export
    </Button>
  );
};

export default ExportCSV;
